// extracted by mini-css-extract-plugin
export default {"dropdown":"index_dropdown_dNeHy","avatar":"index_avatar__qHjr"};